import React from 'react';
import { TextInput, required, FormDataConsumer, useTranslate } from 'react-admin';
import { HiddenInput, ReferenceInput } from '~/components/ra';
import { SelectInput } from 'react-admin';
import { NumberInput } from 'react-admin';
import { PaymentService } from '~/types/paymentServices';
import { Longdash } from '~/utils';
import { useForm } from 'react-final-form';

const l = (key: string): string => `resources.menu.fields.${key}`;

interface Props {
  edit?: boolean;
  menuId?: string;
  parentId?: string;
}

const ChildForm = (props: Props) => {
  const { edit, menuId, parentId } = props;
  const form = useForm();
  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));
  const validateCode = (value: string): string | undefined => {
    return /^[A-Z0-9_]*$/.test(value) ? undefined : t('codeValidation');
  };
  const validateId = (value: string): string | undefined => {
    return /^[a-zA-Z0-9_-]*$/.test(value) ? undefined : t('idValidation');
  };
  return (
    <FormDataConsumer>
      {({ formData }: any) => {
        const hasFallback = formData?.fallbackDescription || formData?.fallbackName;
        return (
          <>
            {edit && <HiddenInput source='id' />}
            {parentId && menuId !== parentId && (
              <HiddenInput source='parentId' defaultValue={parentId} />
            )}
            {menuId && <HiddenInput source='menuId' defaultValue={menuId} />}
            <SelectInput
              source='itemType'
              label={t('itemType')}
              validate={required()}
              choices={[
                { id: 'GROUP', name: t('GROUP') },
                { id: 'SERVICE', name: t('SERVICE') },
                { id: 'ACTION', name: t('ACTION') },
              ]}
              onChange={(_: any, value: string) => {
                if (!edit && value !== 'GROUP') {
                  form.change('id', undefined);
                }
              }}
            />
            {!edit && formData.itemType === 'GROUP' && (
              <TextInput source='id' label={t('id')} validate={validateId} />
            )}
            {formData.itemType === 'SERVICE' && (
              <ReferenceInput
                label={t('serviceId')}
                source='serviceId'
                reference='paymentServices'
                validate={required()}
              >
                <SelectInput
                  optionText={(paymentService: PaymentService) =>
                    `${paymentService?.id} (${paymentService?.name ?? Longdash})`
                  }
                />
              </ReferenceInput>
            )}
            {formData.itemType === 'ACTION' && (
              <TextInput source='actionId' label={t('actionId')} validate={required()} />
            )}
            <TextInput source='code' label={t('code')} validate={[required(), validateCode]} />
            {hasFallback && (
              <TextInput source='fallbackName' label={t('fallbackName')} validate={required()} />
            )}
            {hasFallback && (
              <TextInput
                source='fallbackDescription'
                label={t('fallbackDescription')}
                multiline
                rows={5}
                rowsMax={20}
              />
            )}
            <NumberInput source='index' label={t('priorityIndex')} min={0} step={1} />
          </>
        );
      }}
    </FormDataConsumer>
  );
};

export default ChildForm;
